import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Frozen yoghurt', 1590, 6.0, 24, 1000),
  createData('Ice cream sandwich', 1470, 9.0, 37, 200),
  createData('Eclair', 1003, 16.0, 24, 300),
  createData('Cupcake', 666, 3.7, 67, 205),
  createData('Gingerbread', 555, 16.0, 49, 398),
];

export default function Ranking() {
  return (
    <div>
        <h1>Ranking</h1>
        <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>音乐</TableCell>
            <TableCell align="right">播放量</TableCell>
            <TableCell align="right">价格</TableCell>
            <TableCell align="right">收藏数</TableCell>
            <TableCell align="right">点赞数</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.calories}</TableCell>
              <TableCell align="right">{row.fat}</TableCell>
              <TableCell align="right">{row.carbs}</TableCell>
              <TableCell align="right">{row.protein}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    </div>
    
  );
}